/** @param {{ count: number, label: string, icon: string }} props */
export const PortfolioSummaryCard = function PortfolioSummaryCard({ count, label, icon }) {
    return (
        <div className="g-col-12 g-col-sm-6 g-col-lg-3">
            <div className="small-box">
                <div className="small-box__count">
                    {count}
                </div>

                <div className="inner">
                    <p>{label}</p>
                </div>

                <div className="icon">
                    <i className={icon}></i>
                </div>
            </div>
        </div>
    );
};
